import Lenis from 'lenis';

/**
 * 初始化平滑捲動，等所有頁面資源載入後再啟動 Lenis
 */
const lenisSmoothScroll = function () {
  // 等到 window load 事件，確保圖片、字型等都已載入完成
  window.addEventListener('load', () => {
    const lenis = new Lenis({

      // 使用 lerp 進行線性插值，值越小滑行越久
      lerp: 0.05,
      allowNestedScroll: true,   // 允許巢狀 scroll
      orientation: 'vertical',
      smoothWheel: true,      // 啟用平滑滾輪
      wheelMultiplier: 1,     // 滾輪靈敏度
      smoothTouch: true,      // 啟用平滑觸控
      touchMultiplier: 2,     // 觸控靈敏度
      normalizeWheel: true,   // 正規化滾輪事件
      infinite: false         // 非無限滾動
    });

    // 啟動 requestAnimationFrame 迴圈
    const loop = (time) => {
      lenis.raf(time);
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  });
};

export default lenisSmoothScroll;